import React from "react";
/**
 * Render the grid of days for a specific month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function MonthGrid(props) {
    return React.createElement("table", { ...props });
}
